import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { tableNames } from '../../app/app.constants';
import { GlobalVars } from '../../app/app.environment';
import { FirebaseProvider } from '../firebase/firebase';
import { Check } from '../../models/check';
import { QueryModel } from '../../models/query';


@Injectable()
export class FraudProvider {

  constructor(
    public firebaseService: FirebaseProvider,
    public globalVars: GlobalVars,
  ) {}

  /**
   * Recuperar últims [number] fitxatges, amb opció de filtar per data.
   * 
   * @param number Número de fitxatges a recuperar.
   * @param date Data opcional, per filtar.
   */
  getLastFrauds(number: number, date?: Date): Observable<Check[]> {
    let query = new QueryModel();

    if(date) {
      var date = new Date(date);
      var dataInici = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
      var dataFinal = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1, 0, 0, 0, 0);
      
      var timestampInici = dataInici.getTime();
      var timestampFinal = dataFinal.getTime();
      
      query.orderByChild = 'timestamp';
      query.startAt = timestampInici;
      query.endAt = timestampFinal;
    }

    query.limitToLast = number;

    return this.firebaseService.list(this.getBaseRoot(), query).map(checks => checks.reverse());
  }

  /**
   * Eliminar frau segons ID.
   * 
   * @param fraudId ID del frau a eliminar.
   */
  remove(fraudId): Promise<void> {
    return this.firebaseService.remove(this.getBaseRoot(), fraudId)
  }

  /**
   * Arrel base dins la base de dades.
   */
  private getBaseRoot(): string {
    return tableNames.Repo + '/' + this.globalVars.user.repo + '/' + tableNames.Frauds;
  }

}



// WEBPACK FOOTER //
// ./src/providers/fraud/fraud.ts